var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customer",class:{'scoll':_vm.scollFlag}},[_c('span',{staticClass:"imgBox",on:{"click":_vm.cust}},[_c('img',{attrs:{"src":require("../assets/imgs/emit.png"),"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }